import localforage from 'localforage';

/**
 * Recupera i parametri extra per il redirect MSAL (consumerRef, customerName).
 * Questi valori sono salvati in localforage dopo un login/init riuscito e vengono
 * passati a B2C per precompilare i campi nel form di login.
 *
 * @returns Oggetto con consumerRef e customerName da passare come extraQueryParameters
 */
export const getExtraQueryParamsForRedirect = async (): Promise<{
  consumerRef?: string;
  customerName?: string;
}> => {
  try {
    const [workplaceRef, workplaceName] = await Promise.all([
      localforage.getItem<string>('terminal_FOCUSCLOUD_workplaceRef'),
      localforage.getItem<string>('terminal_FOCUSCLOUD_workplaceName'),
    ]);

    return {
      consumerRef: workplaceRef || undefined,
      customerName: workplaceName || undefined,
    };
  } catch (error) {
    console.warn(
      'Errore durante la lettura dei parametri per il redirect MSAL:',
      error,
    );
    return {};
  }
};
